import AsyncLoader from './AsyncLoader';

/*
	Use AsyncLoader for sweet page based code splitting
*/

const Home = AsyncLoader(() => import('../Home'));
const Posts = AsyncLoader(() => import('../Posts'));
const NotFound = AsyncLoader(() => import('../NotFound'));

const PageIndex = [
	{
		slug: '',
		exact: true,
		label: 'Home',
		component: Home,
	},
	{
		slug: 'posts',
		component: Posts,
	},
	{
		slug: '*',
		component: NotFound,
	},
];

export default PageIndex;



// WEBPACK FOOTER //
// ./src/components/Root/PageIndex.js